(function () {
  const ITEM = '.header-categories-nav__item--dropdown';
  const DETAILS = '.header-categories-nav__details';
  const DROPDOWN = '.header-categories-nav__dropdown';
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function isDesktopDirectNav() {
    return DESKTOP_MQ.matches;
  }

  function isVisible(item) {
    if (isDesktopDirectNav()) return false;
    const details = item.querySelector(DETAILS);
    if (!details) return false;
    if (DESKTOP_MQ.matches) {
      return details.open || item.matches(':hover');
    }
    return details.open;
  }

  function closeAll(exceptDetails) {
    document.querySelectorAll(`${ITEM} ${DETAILS}[open]`).forEach((details) => {
      if (exceptDetails && details === exceptDetails) return;
      details.removeAttribute('open');
      const item = details.closest(ITEM);
      if (item) positionDropdown(item);
    });
  }

  function positionDropdown(item) {
    const details = item.querySelector(DETAILS);
    const summary = details?.querySelector('summary');
    const dropdown = details?.querySelector(DROPDOWN);
    if (!summary || !dropdown) return;

    if (!isVisible(item)) {
      dropdown.style.removeProperty('position');
      dropdown.style.removeProperty('top');
      dropdown.style.removeProperty('left');
      dropdown.style.removeProperty('right');
      dropdown.style.removeProperty('transform');
      dropdown.style.removeProperty('z-index');
      dropdown.style.removeProperty('display');
      return;
    }

    const rect = summary.getBoundingClientRect();
    const center = rect.left + rect.width / 2;
    const minLeft = 12;
    const maxLeft = window.innerWidth - 12;

    dropdown.style.position = 'fixed';
    dropdown.style.transform = 'translateX(-50%)';
    dropdown.style.right = 'auto';
    dropdown.style.zIndex = '1000';

    const offsetEl = dropdown.offsetParent;
    const offsetLeft = offsetEl instanceof Element ? offsetEl.getBoundingClientRect().left : 0;
    const offsetTop = offsetEl instanceof Element ? offsetEl.getBoundingClientRect().top : 0;

    dropdown.style.top = `${rect.bottom + 4 - offsetTop}px`;
    dropdown.style.left = `${Math.min(Math.max(center, minLeft), maxLeft) - offsetLeft}px`;
  }

  function bindItem(item) {
    if (item.dataset.andradeDropdownBound) return;
    item.dataset.andradeDropdownBound = '1';

    const details = item.querySelector(DETAILS);
    if (!details) return;

    item.addEventListener('mouseenter', () => positionDropdown(item));
    item.addEventListener('mouseleave', () => {
      window.requestAnimationFrame(() => positionDropdown(item));
    });

    details.addEventListener('toggle', () => {
      if (details.open) {
        closeAll(details);
      }
      positionDropdown(item);
    });
  }

  function refreshAll() {
    document.querySelectorAll(ITEM).forEach(positionDropdown);
  }

  function onDocumentPointerDown(event) {
    if (!(event.target instanceof Element)) return;

    const insideItem = event.target.closest(ITEM);
    if (insideItem) return;

    closeAll(null);
  }

  function onDocumentKeyDown(event) {
    if (event.key !== 'Escape') return;
    closeAll(null);
  }

  function init() {
    if (isDesktopDirectNav()) return;
    document.querySelectorAll(ITEM).forEach(bindItem);
    document.addEventListener('pointerdown', onDocumentPointerDown);
    document.addEventListener('keydown', onDocumentKeyDown);
    window.addEventListener('resize', refreshAll, { passive: true });
    window.addEventListener('scroll', refreshAll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
